import { combineReducers } from 'redux'

import facets from 'store/reducers/facets'
import filters from 'store/reducers/filters'
import frontendSettings from 'store/reducers/frontendSettings'
import funderGiftHistory from 'store/reducers/giftHistory'
import giftSearch from 'store/reducers/giftSearch'
import grantfit from 'store/reducers/grantfit'
import notes from 'store/reducers/notes'
import pageSettings from 'store/reducers/pageSettings'
import pipeline from 'store/reducers/pipeline'
import pipelineCards from 'store/reducers/pipelineCards'
import pipelineStages from 'store/reducers/pipelineStages'
import profile from 'store/reducers/profile'
import savedSearches from 'store/reducers/savedSearches'
import search from 'store/reducers/search'
import searchPagination from 'store/reducers/searchPagination'
import user from 'store/reducers/user'

export default combineReducers({
  facets,
  filters,
  frontendSettings,
  funderGiftHistory,
  giftSearch,
  grantfit,
  notes,
  pageSettings,
  pipeline,
  pipelineCards,
  pipelineStages,
  profile,
  savedSearches,
  search,
  searchPagination,
  user
})
